var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import hoistNonReactStatics from "hoist-non-react-statics";
import { observer } from "mobx-react";
import { get, set } from "lodash";
import { each, isFn, isStr } from "@al/aku-lc-helpers";
import { useWidget } from "../hooks";
export function mapProps() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (target) {
        return observer(function (props) {
            var widget = useWidget();
            if (!widget) {
                return React.createElement(target, props);
            }
            var results = args.reduce(function (props, mapper) {
                if (isFn(mapper)) {
                    props = Object.assign(props, mapper(props, widget));
                }
                else {
                    each(mapper, function (to, from) {
                        var fromValue = get(widget, from);
                        var target = isStr(to) ? to : from;
                        if (from === "value" && to !== from) {
                            delete props.value;
                        }
                        set(props, target, fromValue);
                    });
                }
                return props;
            }, __assign({}, props));
            return React.createElement(target, results);
        });
    };
}
export function connect(target) {
    var mappers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        mappers[_i - 1] = arguments[_i];
    }
    var Target = mappers.reduce(function (prevTarget, mapper) {
        return mapper(prevTarget);
    }, target);
    var Destination = React.forwardRef(function (props, ref) {
        return React.createElement(Target, __assign(__assign({}, props), { ref: ref }));
    });
    Destination.displayName = "";
    if (target) {
        hoistNonReactStatics(Destination, target);
    }
    return Destination;
}
